import type { ComponentProps } from 'react';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';

function SafeLink({ href, children }: ComponentProps<'a'>) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}

/**
 * Renders ZeroFox report bodies, which arrive as raw Markdown (italics, bullet
 * lists, etc.). Rendering it as Markdown keeps the formatting faithful to how it
 * appears in the source system. Images are disallowed and links open safely in a
 * new tab.
 */
export function RichText({ text }: { text?: string }) {
  if (!text || !text.trim()) {
    return <>—</>;
  }

  return (
    <Markdown remarkPlugins={[remarkBreaks]} disallowedElements={['img']} unwrapDisallowed components={{ a: SafeLink }}>
      {text}
    </Markdown>
  );
}
